
import PIXI from '../GameEngine/pixi.js';
import Button from './ButtonSolid.js'
import ButtonSmall from './ButtonSmall.js'
import RoundSummaryHorizontal from './RoundSummaryHorizontal.js';
export default class RoundSummary extends PIXI.Container {
    constructor(...arg) {
        super(...arg);
        this.title = "Round Summary"
        this.round = 1;
        this.interactive = true;
        this.on('pointerdown', this.close_onClick.bind(this));


        //popupBackground
        var popupBackground = new PIXI.Graphics();
        popupBackground.beginFill(0x000000);
        popupBackground.drawRect(-500, -500, 1000, 1000);
        popupBackground.alpha = 0.1;
        this.addChild(popupBackground);

        this.container = new PIXI.Container();
        this.addChild(this.container);


        const width = 500;

        // this.color = color|| 0x479ACE;// or 0x479ACE or 0xC03500
        this.color = 0x479ACE;// or 0x479ACE or 0xC03500
        //titleBox
        var titleBox = new PIXI.Graphics();
        titleBox.beginFill(this.color);
        titleBox.drawRoundedRect(0, 0, width, 80, 10);
        // titleBox.beginFill(0x333333);
        // titleBox.drawRoundedRect(0, 400, 550, 80, 10);
        this.container.addChild(titleBox);


        //background
        var graphics = new PIXI.Graphics();
        graphics.beginFill(0x333333);
        graphics.drawRect(0, 50, width, 350);
        this.container.addChild(graphics);


        let styleTitle = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 30 * 2,
            fill: '#FFFFFF',
            align: 'center'
        });
        var styleLarge = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 32 * 2,
            fill: '#FFFFFF'
        });
        var styleNormal = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 24 * 2,
            fill: '#FFFFFF'
        });
        let styleSmall = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 12 * 2,
            fill: '#FFFFFF'
        });

        //textTitle
        this.textTitle = new PIXI.Text(this.title, styleTitle);
        this.textTitle.x = width/2;
        this.textTitle.y = 7;
        this.textTitle.anchor.set(0.5, 0);
        this.textTitle.scale.set(0.5);
        this.container.addChild(this.textTitle);

       
        //round summary
        this.roundSummary = new  RoundSummaryHorizontal();
        this.roundSummary.x = (width/2) - (this.roundSummary.width/2);
        this.roundSummary.y = 100;
        
        this.container.addChild(this.roundSummary);
        



        //textTapToContinue
        this.textTapToContinue = new PIXI.Text('Tap to continue', styleSmall);
        this.textTapToContinue.x = width/2;
        this.textTapToContinue.y = 385;
        this.textTapToContinue.anchor.set(0.5, 0);
        this.textTapToContinue.scale.set(0.5);
        this.container.addChild(this.textTapToContinue);


        //center content
        this.container.x = 0 - (this.container.width / 2);
        this.container.y = 0 - (this.container.height / 2);
    }

    updateScore(scoreSummary) {
        
        this.roundSummary.updateLayout(scoreSummary);

        //this.textAnalyzeSummary.text = 'Optimal discard score: ' + (this.analyzeSummary || 0);
    }
    btnExplain_onClick(event) {
        if (this.onExplain) {
            this.onExplain(this.round);
        }
        event.stopPropagation();
    }
    btnNext_onClick(event) {
        if (this.onClose) {
            this.onClose();
        }
        this.visible = false;
        this.parent.isDirty = true;
        // this.parent.isDirty = true;
        // this.parent.removeChild(this);
        event.stopPropagation();
    }
    btnAnalyze_onClick(event) {
        if (this.onAnalyze) {
            this.onAnalyze(this.round);
        }
        event.stopPropagation();
    }
    close_onClick(event) {
        if (this.onClose) {
            this.onClose();
        }
        this.parent.isDirty = true;
        this.parent.removeChild(this);
        event.stopPropagation();
    }
}